import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import LoadingScreen from "../components/LoadingScreen/LoadingScreen";
import ContactUs from "../pages/ContactUs/ContactUs";
import NotFoundPage from "../pages/NotFound/NotFound";
import FaqPage from "../pages/FAQ/FAQ";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import DonatePage from "../pages/Donate/DonatePage";
import TermsPage from "../pages/Terms/Terms";
import AboutPage from "../pages/About/About";
import FeaturesPage from "../pages/Features/Features";
import SingleBlogPost from "../pages/SingleBlogPost/SingleBlogPost";

const lazyWithDelay = (importFunc: () => Promise<any>, delay: number) => {
  return lazy(() =>
    Promise.all([
      importFunc(),
      new Promise((resolve) => setTimeout(resolve, delay)),
    ]).then(([moduleExports]) => moduleExports)
  );
};

// Set your desired loading duration
const LOADING_DURATION = 3000;

// Lazy load components with the same delay as loading screen
const HomePage = lazyWithDelay(
  () => import("../pages/HomePage/HomePage"),
  LOADING_DURATION
);

const BlogPage = lazyWithDelay(
  () => import("../pages/Blog/Blog"),
  LOADING_DURATION
);

const AppRoutes: React.FC = () => {
  return (
    <Suspense
      fallback={
        <LoadingScreen
          duration={LOADING_DURATION} // Same duration as lazy loading delay
          customMessage="Loading Page..."
          showProgress={true}
        />
      }
    >
      <Routes>
        {/* Home page - main marketing page */}
        <Route path={ROUTES.HOME.path} element={<HomePage />} />

        {/* About page - company story and mission */}
        <Route path={ROUTES.ABOUT.path} element={<AboutPage />} />

        {/* Features page - comprehensive platform overview */}
        <Route path={ROUTES.FEATURES.path} element={<FeaturesPage />} />

        {/* FAQ page - support and information */}
        <Route path={ROUTES.FAQ.path} element={<FaqPage />} />

        {/* Contact Us page - support and information */}
        <Route path={ROUTES.CONTACTUS.path} element={<ContactUs />} />

        {/* Terms page - legal information */}
        <Route path={ROUTES.TERMS.path} element={<TermsPage />} />

        {/* Legal pages */}
        <Route path={ROUTES.PRIVACY.path} element={<PrivacyPolicy />} />

        {/* Donation pages - main dynamic functionality */}
        <Route path={ROUTES.DONATE.path} element={<DonatePage />} />

        {/* Blog pages - healthcare insights and expert advice */}
        <Route path={ROUTES.BLOG.path} element={<BlogPage />} />

        <Route
          path={`${ROUTES.BLOG.path}/:slug`}
          element={<SingleBlogPost />}
        />

        {/* 404 Not Found Route - Must be last */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
